/* eslint-disable babel/camelcase */
import { StyleSheet } from '@rexlabs/styling';
export default StyleSheet({
  container: {
    textAlign: 'center',
    padding: '0 13px',
    verticalAlign: 'top',
    userSelect: 'none'
  },
  month: {
    borderCollapse: 'collapse',
    borderSpacing: 0
  },
  title: {
    captionSide: 'initial',
    color: 'dimgray',
    marginTop: 7,
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 2,
    padding: '15px 0 35px',
    fontWeight: 900
  },
  title_verticalScrollable: {
    padding: '5px 0'
  },
  grid: {},
  week: {},
  horizontal: {
    display: 'inline-block',
    minHeight: '100%',
    ':first-of-type': {
      position: 'absolute',
      zIndex: '0',
      opacity: '0',
      pointerEvents: 'none'
    }
  },
  vertical: {
    display: 'block',
    ':first-of-type': {
      position: 'absolute',
      zIndex: '0',
      opacity: '0',
      pointerEvents: 'none'
    }
  },
  verticalScrollable: {}
});